"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(require("moment"));
var states_1 = require("../../../../common/constants/states");
var json_1 = require("../../../../common/helpers/json");
var AdminStudentEditController = /** @class */ (function () {
    function AdminStudentEditController($state, $stateParams, UsersModel, FlashService, sessiontypes, coursetypes, PoliciesModel) {
        var _this = this;
        this.initialLoad = true;
        this.$state = $state;
        this.states = states_1.States;
        this.UsersModel = UsersModel;
        this.FlashService = FlashService;
        this.PoliciesModel = PoliciesModel;
        this.submitted = false;
        this.hourOptions = [];
        for (var i = 0; i <= 100; i++) {
            this.hourOptions.push({
                value: i.toString(),
                name: i.toString() + ' Hours'
            });
        }
        this.student = {
            id: 0,
            parent: {
                number: "",
                issuedate: "",
                expirationdate: ""
            },
            updatedSessionHours: {},
            updatedCourseHours: {},
            usermeta: {
                dob: "",
                start_date: "",
                formatted_drive_deadline: "",
                receives_last_minute_text_reminders: "",
                guardian: {
                    firstname: "",
                    lastname: "",
                    reminders: {
                        receives_last_minute_text_reminders: "",
                    }
                },
                formatted_permit_expiration_date: "",
                formatted_permit_issue_date: "",
                permit: {
                    issuedate: "",
                    expirationdate: "",
                    number: ""
                },
            },
            school: {
                address: {
                    street: "",
                    city: "",
                    state: "",
                    zip: ""
                }
            },
        };
        this.editPassword = false;
        this.hoursPurchased = {
            'hours': '2',
            'minutes': '0'
        };
        this.stateRequiresPermit = false;
        this.preferred_pronoun_enabled = false;
        PoliciesModel.getByID('studentmetadata').then(function (response) {
            var policyMeta = {};
            response.policy.policymeta.forEach(function (meta) {
                policyMeta[meta.meta_key] = meta.meta_value;
            });
            if (policyMeta.preferred_pronoun) {
                _this.preferred_pronoun_enabled = true;
            }
        });
        UsersModel.getStudentByID($stateParams.userId).then(function (response) {
            /* @ts-ignore */
            response.school.address = (0, json_1.isJson)(response.school.address) ? JSON.parse(response.school.address) : response.school.address;
            response.usermeta.start_date = (0, moment_1.default)(response.usermeta.start_date, 'YYYY-MM-DD').format('MM/DD/YYYY');
            response.usermeta.dob = (0, moment_1.default)(response.usermeta.dob, 'YYYY-MM-DD').format('MM/DD/YYYY');
            if (response.usermeta.hasOwnProperty('permit')) {
                response.usermeta.permit.issuedate = (0, moment_1.default)(response.usermeta.permit.issuedate, 'YYYY-MM-DD').format('MM/DD/YYYY');
                response.usermeta.permit.expirationdate = (0, moment_1.default)(response.usermeta.permit.expirationdate, 'YYYY-MM-DD').format('MM/DD/YYYY');
            }
            _this.sessiontypes = [];
            sessiontypes.forEach(function (sessionType) {
                // allows observations?
                if (sessionType.allow_observations === false) {
                    // only add non observation hours
                    /* @ts-ignore */
                    var purchasedHours = response.purchasedtime.filter(function (time) {
                        return time.session_type_id !== null && (time.sessiontype.id === sessionType.id) && time.observation === false;
                    });
                    var durMoment = _this.parseDuration(purchasedHours);
                    _this.sessiontypes.push({
                        'name': sessionType.name,
                        'id': sessionType.id,
                        'hours': durMoment[0],
                        'observation': false,
                        'minutes': typeof (durMoment[1]) === 'undefined' ? '0' : durMoment[1]
                    });
                }
                else {
                    // add the observation and non observation hours
                    /* @ts-ignore */
                    var purchasedHours = response.purchasedtime.filter(function (time) {
                        return time.session_type_id !== null && (time.sessiontype.id === sessionType.id) && time.observation === false;
                    });
                    var durMoment = _this.parseDuration(purchasedHours);
                    _this.sessiontypes.push({
                        'name': sessionType.name,
                        'id': sessionType.id,
                        'hours': durMoment[0],
                        'observation': false,
                        'minutes': typeof (durMoment[1]) === 'undefined' ? '0' : durMoment[1]
                    });
                    /* @ts-ignore */
                    var purchasedObservationHours = response.purchasedtime.filter(function (time) {
                        return time.session_type_id !== null && (time.sessiontype.id === sessionType.id) && time.observation === true;
                    });
                    durMoment = _this.parseDuration(purchasedObservationHours);
                    _this.sessiontypes.push({
                        'name': sessionType.name,
                        'id': sessionType.id,
                        'hours': durMoment[0],
                        'observation': true,
                        'minutes': typeof (durMoment[1]) === 'undefined' ? '0' : durMoment[1]
                    });
                }
            });
            _this.coursetypes = [];
            coursetypes.forEach(function (sessionType) {
                /* @ts-ignore */
                var purchasedHours = response.purchasedtime.filter(function (time) {
                    return time.course_type_id !== null && (time.coursetype.id === sessionType.id);
                });
                var durMoment = _this.parseDuration(purchasedHours);
                _this.coursetypes.push({
                    'name': sessionType.name,
                    'id': sessionType.id,
                    'hours': durMoment[0],
                    'minutes': typeof (durMoment[1]) === 'undefined' ? '0' : durMoment[1]
                });
            });
            /* @ts-ignore */
            _this.student = response;
            _this.stateRequiresPermit = _this.student.school.address.state === 'GA' || _this.student.school.address.state === 'CA' || _this.student.school.address.state === 'PA' || _this.student.school.address.state === 'MO' || _this.student.school.address.state === 'KY' || _this.student.school.address.state === 'NY' || _this.student.school.address.state === 'AZ';
            _this.initialLoad = false;
        });
    }
    AdminStudentEditController.prototype.parseDuration = function (purchasedHours) {
        var _durMoment;
        if (typeof purchasedHours[0] !== 'undefined') {
            if (purchasedHours[0].hours < 60) {
                _durMoment = ["0", purchasedHours[0].hours.toString()];
            }
            else {
                // @ts-ignore
                _durMoment = moment_1.default.duration(parseInt(purchasedHours[0].hours), 'minutes').format('H:m').split(':');
            }
        }
        else {
            _durMoment = ["0", "0"];
        }
        return _durMoment;
    };
    AdminStudentEditController.prototype.getStudentAge = function () {
        if (typeof this.student.usermeta.dob === 'undefined') {
            return 100;
        }
        var dob = (0, moment_1.default)(this.student.usermeta.dob, 'MMDDYYYY').toDate();
        return (0, moment_1.default)(new Date()).diff((0, moment_1.default)(dob), 'years');
    };
    AdminStudentEditController.prototype.updateStudent = function () {
        var _this = this;
        this.submitted = true;
        var request = Object.assign({}, this.student);
        for (var key in request.usermeta) {
            var value = request.usermeta[key];
            if (value === null || value === "") {
                delete request.usermeta[key];
            }
        }
        if (request.usermeta.hasOwnProperty('permit')) {
            try {
                request.usermeta.formatted_permit_issue_date = (0, moment_1.default)(request.usermeta.permit.issuedate, 'MM/DD/YYYY').format('YYYY-MM-DD');
                request.usermeta.formatted_permit_expiration_date = (0, moment_1.default)(request.usermeta.permit.expirationdate, 'MM/DD/YYYY').format('YYYY-MM-DD');
            }
            catch (Error) {
                delete request.usermeta.formatted_permit_expiration_date;
                delete request.usermeta.formatted_permit_issue_date;
                delete request.usermeta.permit;
            }
        }
        delete request.usermeta.formatted_drive_deadline;
        request.usermeta.start_date = (0, moment_1.default)(request.usermeta.start_date, 'MM/DD/YYYY').format('YYYY-MM-DD');
        request.usermeta.dob = (0, moment_1.default)(request.usermeta.dob, 'MM/DD/YYYY').format('YYYY-MM-DD');
        request.updatedSessionHours = this.sessiontypes;
        request.updatedCourseHours = this.coursetypes;
        request.usermeta.receives_last_minute_text_reminders = 'N';
        if (request.usermeta.hasOwnProperty('guardian')) {
            if (!request.usermeta.guardian.hasOwnProperty('reminders')) {
                request.usermeta.guardian.reminders = {
                    'receives_last_minute_text_reminders': 'N'
                };
            }
            else {
                request.usermeta.guardian.reminders.receives_last_minute_text_reminders = 'N';
            }
        }
        this.UsersModel.updateStudent(request).then(function (response) {
            _this.submitted = false;
            _this.FlashService.setMessage({
                'type': 'success',
                'message': response.message
            });
            _this.$state.go('drivecoach.admin.students.view', { 'userId': _this.student.id });
        }).catch(function (error) {
            _this.submitted = false;
        });
    };
    return AdminStudentEditController;
}());
AdminStudentEditController.$inject = ['$state', '$stateParams', 'UsersModel', 'FlashService', 'sessiontypes', 'coursetypes', 'PoliciesModel'];
exports.default = AdminStudentEditController;
